










import { CategoryItem } from '@/interfaces/category-item';
import MenuMixin from '@/mixins/menu-mixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import Left from '../layout/left.vue';
const System = namespace('System');

@Component({
  components: { Left }
})
export default class Analyze extends mixins(MenuMixin) {
  @State MENU_INDENT: any;

  @System.State activeTabs: any;
  @System.Mutation setActiveTabs: any;

  menu: CategoryItem[] = [
    { title: '客户旅程指标分析驾驶仓', icon: 'fa-cubes', type: 'folder', oprate: false, expand: true, children: [] },
    { title: '板块部门指标运营驾驶仓', icon: 'fa-cubes', type: 'folder', oprate: false, expand: true, children: [] },
    { title: '卓越运营指标监控驾驶仓', icon: 'fa-cubes', type: 'folder', oprate: false, expand: true, children: [] }
  ];

  created() {
    this.initMenu();
  }

  initMenu() {
    if (this.ROLE_MENU.length === 0) {
      setTimeout(() => {
        this.initMenu();
      }, 100);
    } else {
      this.MENU('JA_BOARD_CUSTOM') && this.menu[0].children.push({ title: '自助指标分析', key: '/analyze/custom/main', oprate: false, icon: 'fa-magic' });
      this.MENU('JA_BOARD_SUMMARY') && this.menu[0].children.push({ title: '客户旅程分析仪表盘', key: '/analyze/dashboard', oprate: false, icon: 'fa-line-chart' });
      this.MENU('JA_BOARD_PM') && this.menu[0].children.push({ title: '产品管理', key: '/analyze/scene_pm', oprate: false, icon: 'fa-line-chart' });
      this.MENU('JA_BOARD_CA') && this.menu[0].children.push({ title: '客户获取', key: '/analyze/scene_ca', oprate: false, icon: 'fa-line-chart' });
      this.MENU('JA_BOARD_CI') && this.menu[0].children.push({ title: '客户申请发卡', key: '/analyze/scene_ci', oprate: false, icon: 'fa-line-chart' });
      this.MENU('JA_BOARD_CO') && this.menu[0].children.push({ title: '客户经营', key: '/analyze/scene_co', oprate: false, icon: 'fa-line-chart' });
      this.MENU('JA_BOARD_CS') && this.menu[0].children.push({ title: '客户服务', key: '/analyze/scene_cs', oprate: false, icon: 'fa-line-chart' });
      this.MENU('JA_BOARD_TP') && this.menu[0].children.push({ title: '交易处理', key: '/analyze/scene_tp', oprate: false, icon: 'fa-line-chart' });
      this.MENU('JA_BOARD_BR') && this.menu[0].children.push({ title: '账单还款', key: '/analyze/scene_bp', oprate: false, icon: 'fa-line-chart' });
      this.MENU('JA_BOARD_DR') && this.menu[0].children.push({ title: '债务回收', key: '/analyze/scene_dr', oprate: false, icon: 'fa-line-chart' });
      this.MENU('PA_BOARD_SUMMARY') && this.menu[1].children.push({ title: '板块部门运营仪表盘', key: '/analyze/unit_dashboard', oprate: false, icon: 'fa-bar-chart' });
      this.MENU('PA_BOARD_CH') && this.menu[1].children.push({ title: '渠道板块', key: '/analyze/unit_channel', oprate: false, icon: 'fa-line-chart' });
      this.MENU('PA_BOARD_MK') && this.menu[1].children.push({ title: '市场板块', key: '/analyze/unit_market', oprate: false, icon: 'fa-line-chart' });
      this.MENU('PA_BOARD_RS') && this.menu[1].children.push({ title: '风险板块', key: '/analyze/unit_risk', oprate: false, icon: 'fa-line-chart' });
      this.MENU('PA_BOARD_OP') && this.menu[1].children.push({ title: '运营板块', key: '/analyze/unit_operation', oprate: false, icon: 'fa-line-chart' });
      this.MENU('DATAV_BOARD_IND') && this.menu[2].children.push({ title: '卓越运营指标监控大屏', key: '/screen/indicator', oprate: false, icon: 'fa-line-chart' });
    }
  }

  update(key: string) {
    if (/\/screen/.test(key)) {
      let routeData = this.$router.resolve({ path: key });
      window.open(routeData.href, '_blank');
      return;
    }
    if (/\/analyze/.test(key)) {
      let index = this.activeTabs.findIndex((v: any) => v.path.startsWith(key));
      if (index > -1) {
        this.setActiveTabs(this.activeTabs[index]);
        this.$router.push(this.activeTabs[index].fullPath);
      } else {
        this.$router.push(key);
      }
    }
  }
}
